var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "nav-footer" }, [
    _vm.tenantInfo.name
      ? _c("span", [_vm._v("主办单位：" + _vm._s(_vm.tenantInfo.name))])
      : _vm._e(),
    _vm._v(" "),
    _vm.tenantInfo.footer
      ? _c("span", [_vm._v(_vm._s(_vm.tenantInfo.footer))])
      : _vm._e(),
    _vm._v(" "),
    _c("span", [_vm._v("技术支持：成都倍豪物业发展集团有限公司")])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c5e71bd6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c5e71bd6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pc/components/shared/NavFooter.vue
// module id = 480
// module chunks = 4